/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDetailsDto } from './CompanyDetailsDto';
export type ThirdPartyContractDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    supplierDetails: CompanyDetailsDto;
    clientDetails: CompanyDetailsDto;
    invoicePayedByDetails: CompanyDetailsDto;
    releaseDocumentationsReceiverDetails: CompanyDetailsDto;
    publicationMadeUnderCompanyDetails: CompanyDetailsDto;
    validFrom?: string;
    thirdPartyState: ThirdPartyContractDto.thirdPartyState;
};
export namespace ThirdPartyContractDto {
    export enum thirdPartyState {
        INACTIVE = 'INACTIVE',
        ACTIVE = 'ACTIVE',
        ARCHIVED = 'ARCHIVED',
    }
}

